import { COU_httpGet } from '@/utils/http'

// 获取店铺里的类目列表
async function GetGoodsCategoryList(isSync) {
  const url = `/util/shopCategory${isSync ? '?isSync=true' : ''}`
  const r = await COU_httpGet({ url })
  let list = [], success = false, msg = ''
  try {
    list = r.result
    success = r.success
    msg = r.msg
  } 
  catch (error) {
    console.log(error)
  }
  return { list: list || [], success, msg }
}

export default {
  GetGoodsCategoryList
}